module.exports = __webpack_public_path__ + "img/akl_file.75471628.png";